import {userContentCss} from "./TaskEvents";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {useState} from "react";
import {ComposeInner} from "./Compose";

export function Description(props: {
    value: string;
    onUpdate(value: string): Promise<any>
}) {
    const [editing, setEditing] = useState(false);

    return (
        <div
            className={descriptionCls}
        >
            <div style={{
                fontWeight: "600",
                fontSize: "0.9rem",
            }}>
                Description
            </div>
            {!editing && <div className={clickableCss} onClick={e => {
                // @ts-ignore
                if(e.target?.tagName === "A") {
                    return;
                }

                e.stopPropagation();
                e.preventDefault();
                setEditing(true);
            }}>
                <div className={userContentCss} dangerouslySetInnerHTML={{__html: props.value || "<i>No description</i>"}}></div>
            </div>}
            {editing && <ComposeInner
                defaultValue={props.value}
                 onSubmit={async (value) => {
                     await props.onUpdate(value);
                     setEditing(false);
                 }}
                 onCancel={() => {
                     setEditing(false);
                 }} />}
        </div>
    )
}

const descriptionCls = css({
    width: "100%",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
})

const clickableCss = css({
    border: "1px solid " + grey["300"],
    borderRadius: 4,
    padding: 6,
    cursor: "pointer",

    "&:hover": {
        border: "1px solid " + grey["300"],
        backgroundColor: grey["300"],
    }
})